var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-manage"},[_c('subfield',[_c('template',{slot:"list"},[_c('trees',{attrs:{"title":_vm.$t('crc1'),"type":"GROUP","list":_vm.groupList},on:{"getAssets":_vm.getAssets}})],1),_c('template',{slot:"content"},[_vm._v("check-manage")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }